export default __webpack_public_path__ + "static/media/project_img_4.ffda02af.jpeg";